import React from "react";
import { Footer, MobNav, Navbar } from "components";

const AppLayout = ({ children }) => {
  return (
    <>
      <Navbar />
      <MobNav />
      {children}
      <Footer />
      <div className="spacing-div"></div>
    </>
  );
};

export default AppLayout;
